import firebase from "./firebase";
import GENRALHELPERS from "./GENRAL-HELPERS";

const spinnerMain = document.getElementById("SpinnerMain");
const spinnerMessage = document.getElementById("SpinnerMessage");

class Spinner {
  #spinnerTimeOut = 10000

  #spinnerStartTimeStamp = "";
  #timeBeforeClosing = 300;
  #spinnerProblemTimer = null;
  #spinnerHideTimer = null;

  _displaySpinner(message = "", timeOut = 10000) {
    this.#spinnerTimeOut = timeOut;
    // A new spinner request cancels any old scheduled close/report.
    clearTimeout(this.#spinnerHideTimer);
    clearTimeout(this.#spinnerProblemTimer);

    this.#spinnerStartTimeStamp = Date.now();

    spinnerMain.classList.remove("SpinnerHide");
    spinnerMain.classList.add("SpinnerShow");
    spinnerMessage.textContent = message;

    // Report only if this specific spinner stays visible for 10 seconds.
    this.#spinnerProblemTimer = setTimeout(() => {
      const spinnerIsVisible = spinnerMain.classList.contains("SpinnerShow");

      if (spinnerIsVisible) {
        this._reportAProblem();
      }

      this.#spinnerProblemTimer = null;
    }, this.#spinnerTimeOut);
  }

  _hideSpinner(force = false) {
    // if (!force) return
    clearTimeout(this.#spinnerHideTimer);

    const hideSpinner = () => {
      spinnerMain.classList.add("SpinnerHide");
      spinnerMain.classList.remove("SpinnerShow");
      spinnerMessage.textContent = "";

      // Spinner is no longer active, so it must not report a timeout.
      clearTimeout(this.#spinnerProblemTimer);
      this.#spinnerProblemTimer = null;
      this.#spinnerHideTimer = null;
    };

    const timeBetween = Date.now() - this.#spinnerStartTimeStamp;
    const timeNeeded = Math.max(0, this.#timeBeforeClosing - timeBetween);

    if (timeNeeded === 0) {
      hideSpinner();
    } else {
      this.#spinnerHideTimer = setTimeout(hideSpinner, timeNeeded);
    }
  }

  async _reportAProblem(titleIn = null, descriptionIn = null) {
    let title = 'Reportar un Error';
    let description = 'Esta aplicación tardó mucho en abrir esta página. Puedes reportarlo aqui. Favor describe lo que estás experimentando, para que podamos trabajar en mejorarlo.';

    if (titleIn) {
      title = titleIn;
    }

    if (descriptionIn) {
      description = descriptionIn;
    }

    const reportAProblemWindow1Title = document.getElementById('reportAProblemWindow1Title')
    const reportAProblemWindow1Description = document.getElementById('reportAProblemWindow1Description')

    reportAProblemWindow1Title.textContent = title;
    reportAProblemWindow1Description.textContent = description;

    const result = await this._confirmReportAProblem();
    this._hideSpinner(true);
    if (result === 'send') {
      // Handle the "send" case
      const input = document.getElementById('reportAProblemWindow1Input')
      const message = input.value.trim();
      if (message.length === 0) {
        alert("El reporte no puede estar vacío. Por favor, describe el problema antes de enviarlo.");
        return;
      }

      const deviceInfo = await GENRALHELPERS._getDeviceInfo()

      const reportData = {
        message,
        timestamp: Date.now(),
        clientPlatformInfo: GENRALHELPERS._getClientPlatformInfo(),
        deviceInfo
      }
      console.log("Sending report:", reportData);
      input.value = ''; // Clear the input field after sending


      const resultSend = await firebase._reportAProblem(reportData);

      if (resultSend?.data?.status === 'success') {
        console.log("Report sent successfully");
      } else {
        alert("Error al envíar el reporte. Puedes envíarnos un correo al: mercadomaionline@gmail.com para reportarlo.")
      }
    }

    if (result === 'cancel') {

    }
    return 'done';
  }



  _confirmReportAProblem() {
    return new Promise((resolve) => {

      const modal = document.getElementById('reportAProblemWindow1');
      const input = document.getElementById('reportAProblemWindow1Input');
      const sendBtn = document.getElementById('reportAProblemWindow1ButtonSend');
      const cancelBtn = document.getElementById('reportAProblemWindow1ButtonCancel');

      if (!modal || !input || !sendBtn || !cancelBtn) {
        resolve('cancel');
        return;
      }

      modal.style.display = 'flex';

      const cleanup = () => {
        sendBtn.removeEventListener('click', handleSend);
        cancelBtn.removeEventListener('click', handleCancel);

        modal.style.display = 'none';
      };

      const handleSend = () => {
        const message = input.value.trim();
        if (message.length === 0) {
          alert("El reporte no puede estar vacío. Por favor, describe el problema antes de enviarlo.");
          return;
        }

        cleanup();
        resolve('send');
        this._thankYouForReportAProblem()
      };

      const handleCancel = () => {
        cleanup();
        resolve('cancel');
      };

      sendBtn.addEventListener('click', handleSend);
      cancelBtn.addEventListener('click', handleCancel);

    });
  }

  _thankYouForReportAProblem() {
    return new Promise((resolve) => {

      const modal = document.getElementById('reportAProblemWindow2');
      const cancelBtn = document.getElementById('reportAProblemWindow2ButtonClose');

      if (!modal || !cancelBtn) {
        resolve('cancel');
        return;
      }

      modal.style.display = 'flex';

      const cleanup = () => {
        cancelBtn.removeEventListener('click', handleCancel);

        modal.style.display = 'none';
      };

      const handleCancel = () => {
        cleanup();
        resolve('cancel');
      };

      cancelBtn.addEventListener('click', handleCancel);

    });
  }
}

export default new Spinner();
